import SharedDrivePage from "./SharedDrivePage";

export default SharedDrivePage;
